import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { AggregationType, AreaFillType } from "./types";

export const name = "metricsAggregations";

export type PageType = "apps_services" | "resources" | "dg2";

interface PageAggregationState {
  selectedAggregation: AggregationType;
  selectedAreaFill: AreaFillType;
}

interface AggregationState {
  byPage: Record<PageType, PageAggregationState>;
}

const defaultPageState: PageAggregationState = {
  selectedAggregation: "avg",
  selectedAreaFill: "none"
};

const initialState: AggregationState = {
  byPage: {
    apps_services: { ...defaultPageState },
    resources: { ...defaultPageState },
    dg2: { ...defaultPageState }
  }
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setAggregation: (
      state,
      action: PayloadAction<{ page: PageType; aggregation: AggregationType }>
    ) => {
      state.byPage[action.payload.page].selectedAggregation =
        action.payload.aggregation;
    },
    setAreaFill: (
      state,
      action: PayloadAction<{ page: PageType; areaFill: AreaFillType }>
    ) => {
      state.byPage[action.payload.page].selectedAreaFill =
        action.payload.areaFill;
    }
  }
});

export default slice.reducer;

export const { setAggregation, setAreaFill } = slice.actions;
